import React, { Component } from 'react';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table } from 'reactstrap';

class CorpRefunds extends Component {
  render() {
    return (
      <div className="page-applications">
        <Container fluid>

          <Row className="mb-3 align-items-center">

            <Col >
              <h3 className="mb-3 mb-md-0 text-center text-md-left">Refunds</h3>
            </Col>

            <Col xs="auto">
              <Form>
                <Row form>
                  <Col xs="auto" className="pl-0 pr-0">
                    <Button color="link" className="text-muted pl-1 pr-1 pl-md-2 pr-md-2">
                      <img src="/icons/download.svg" alt="Export" />
                      <span className="d-none d-md-inline ml-1">Export</span>
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>

          </Row>
          <Row>

            <Col>
              <Card>
                <CardHeader className="text-md-left">All Applications</CardHeader>

                <Table className="mb-0" size="sm" responsive striped borderless hover>
                  <thead>
                    <tr>
                      <th>Merchant</th>
                      <th><span className="text-nowrap">Refund ID</span></th>
                      <th><span className="text-nowrap">Refund Status</span></th>
                      <th>Request Date</th>
                      <th>App ID</th>
                      <th>Applicant</th>
                      <th><span className="text-nowrap">Amt. Financed</span></th>
                      <th><span className="text-nowrap">Refund Amt.</span></th>
                      <th><span className="text-nowrap">New Amt. Financed</span></th>
                      <th><span className="text-nowrap">Debit Amt.</span></th>
                      <th><span className="text-nowrap">Completed Date</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">American Dental – Hollywood</th>
                      <td>15614232</td>
                      <td><Badge color="dark" className="w-100">Complete</Badge></td>
                      <td>04/04/2018</td>
                      <td>15614</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$5,200.00</td>
                      <td>$5,200.00</td>
                      <td>$2,332.00</td>
                      <td>$2,332.00</td>
                      <td>04/05/2018</td>
                    </tr>
                    <tr>
                      <th scope="row">American Dental – Hollywood</th>
                      <td>15614232</td>
                      <td><Badge color="warning" className="w-100">Pending</Badge></td>
                      <td>04/04/2018</td>
                      <td>15614</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$5,200.00</td>
                      <td>$5,200.00</td>
                      <td>$2,332.00</td>
                      <td>$2,332.00</td>
                      <td>—</td>
                    </tr>
                    <tr>
                      <th scope="row">American Dental – Hollywood</th>
                      <td>15614232</td>
                      <td><Badge color="warning" className="w-100">Pending</Badge></td>
                      <td>04/04/2018</td>
                      <td>15614</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$5,200.00</td>
                      <td>$5,200.00</td>
                      <td>$2,332.00</td>
                      <td>$2,332.00</td>
                      <td>—</td>
                    </tr>
                    <tr>
                      <th scope="row">American Dental – Hollywood</th>
                      <td>15614232</td>
                      <td><Badge color="dark" className="w-100">Complete</Badge></td>
                      <td>04/04/2018</td>
                      <td>15614</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$5,200.00</td>
                      <td>$5,200.00</td>
                      <td>$2,332.00</td>
                      <td>$2,332.00</td>
                      <td>04/05/2018</td>
                    </tr>
                    <tr>
                      <th scope="row">American Dental – Hollywood</th>
                      <td>15614232</td>
                      <td><Badge color="dark" className="w-100">Complete</Badge></td>
                      <td>04/04/2018</td>
                      <td>15614</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$5,200.00</td>
                      <td>$5,200.00</td>
                      <td>$2,332.00</td>
                      <td>$2,332.00</td>
                      <td>04/05/2018</td>
                    </tr>
                    <tr>
                      <th scope="row">American Dental – Hollywood</th>
                      <td>15614232</td>
                      <td><Badge color="dark" className="w-100">Complete</Badge></td>
                      <td>04/04/2018</td>
                      <td>15614</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$5,200.00</td>
                      <td>$5,200.00</td>
                      <td>$2,332.00</td>
                      <td>$2,332.00</td>
                      <td>04/05/2018</td>
                    </tr>
                    <tr>
                      <th scope="row">American Dental – Hollywood</th>
                      <td>15614232</td>
                      <td><Badge color="dark" className="w-100">Complete</Badge></td>
                      <td>04/04/2018</td>
                      <td>15614</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$5,200.00</td>
                      <td>$5,200.00</td>
                      <td>$2,332.00</td>
                      <td>$2,332.00</td>
                      <td>04/05/2018</td>
                    </tr>
                  </tbody>
                </Table>

              </Card>
            </Col>

          </Row>
          <Row className="mb-md-3">

            <Container fluid>
              <Row className="align-items-center">
                <Col md={{ size: 4, offset: 4 }}>
                  <Pagination aria-label="Page">
                    <PaginationItem disabled>
                      <PaginationLink previous href="#" />
                    </PaginationItem>
                    <PaginationItem active>
                      <PaginationLink href="#">1</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink href="#">2</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink href="#">3</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink href="#">4</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink href="#">5</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink next href="#" />
                    </PaginationItem>
                  </Pagination>
                </Col>
                <Col md={4} className="text-center text-md-right mt-1 mt-md-0">
                  <small>1–20 of 123 entries</small>
                </Col>
              </Row>
            </Container>

          </Row>
        </Container>
      </div>
    )
  }
}

export default CorpRefunds;
